import React, { useState, useEffect } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import { DownOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import '../userProfileAttendanceDetailsV3.css'

// Import your CSS file

const { RangePicker } = DatePicker;

const FilterComponent = ({ year, setYear, month, setMonth, range, range1, setRange, handleLeftClick, handleRightClick, options, setSelectedOption, selectedOption, joiningYear,isCurrentWeek,onMonthChange }) => {


  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };
  const handleYearChange = (value) => {
    if (value) setYear(value.year());
  };
  const handleMonthChange = (value) => {
    if (value) {onMonthChange(value)};
  };
  const disableYear = (current) => {
    if (!joiningYear) return false;

    return (
      current.year() < joiningYear ||
      current.year() > moment().year()
    );
  };

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      {selectedOption && (
        <>
          {selectedOption !== 'year' && (
            <>
              <DatePicker
                picker="year"
                onChange={handleYearChange}
                value={year ? moment(`${year}`, 'YYYY') : null}
                style={{
                  borderRadius: "50px",
                  width: "80px",
                  height: "25px",
                  border: '1px solid #E6E6E6',
                }}
                disabledDate={disableYear}
              />
              {/* <DatePicker
                picker="month"
                onChange={handleMonthChange}
                value={month ? moment(`${year}-${month}`, 'YYYY-MM') : null}
                format="MMM"
                dropdownClassName="no-year-change"
                style={{
                  borderRadius: "50px",
                  width: "80px",
                  height: "25px",
                  border: '1px solid #E6E6E6',
                }}
              /> */}
            </>
          )}

          {selectedOption === 'days' && (<>
            <DatePicker
              picker="month"
              onChange={handleMonthChange}
              value={month ? moment(`${year}-${month}`, 'YYYY-MM') : null}
              format="MMM"
              dropdownClassName="no-year-change"
              style={{
                borderRadius: "50px",
                width: "80px",
                height: "25px",
                border: '1px solid #E6E6E6',
              }}
            />
            <div

              style={{
                borderRadius: "50px",
                width: "150px",
                height: "25px",
                border: '1px solid #E6E6E6',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: 4, alignItems: 'center' }}>
                <LeftOutlined style={{ color: "#AEAEAE", paddingLeft: 5 }} onClick={handleLeftClick} />
                <div style={{ fontSize: "12px", color: "#636363", marginTop: -2 }}>
                  {range} - {range1}
                </div>
                <RightOutlined style={{ color: isCurrentWeek ? "#D9D9D9" : "#AEAEAE", cursor: isCurrentWeek ? "not-allowed" : "pointer", paddingRight: 5 }} onClick={!isCurrentWeek ? handleRightClick : undefined} />
              </div>
            </div></>
          )}
        </>
      )}
      <div
        style={{
          borderRadius: "50px",
          width: "90px",
          height: "25px",
          border: '1px solid #E6E6E6',
        }}>
        <div style={{ display: "flex", justifyContent: 'center', }}>
          <Select
            bordered={null}
            onChange={handleSelectChange}
            className="custom-select-v3"
            options={options}
            value={selectedOption} // Set the current selected value
            placeholder="Select Option"
            size="small"
            suffixIcon={<DownOutlined />}
          // style={{width: "100%",}}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
